import React from "react";
import BreadScrumb from "../components/BreadScrumb";
import Brand from "../components/Home/Brand";
import Footer from "../components/Footer";
import Header from "../components/Header";

const BrandsPage = () => {
  return (
    <>
      <Header />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb
          title="Select Brands"
          Banner="/assets/images/background/3.webp"
        />
        <Brand />
        <Footer />
      </div>
    </>
  );
};

export default BrandsPage;
